import React, { FC, Fragment } from "react";
import { useSelector } from "react-redux";
import { ReduxState } from "~/types/redux";
import { DEFAULT_HOURS } from "~/constants/config/common";
import InfoCircle from "~/components/Icons/outline/InfoCircle";
import NotificationsStyled, { GlobalNotificationStyle } from "./NotificationsStyled";
import Tooltip from "../Tooltip";
import setHtml from "~/helpers/setHtml";
import { iconMap } from "~/constants/iconMap";
import { trackEvent } from "~/helpers/tracking";
const Notifications: FC = () => {
  const {
    notifications,
    callInNumber,
    monarch,
    singleForm
  } = useSelector((store: ReduxState) => store);
  const {
    cartGlobalHoursOfOperation
  } = monarch;
  const hoursOfOperation = (() => {
    if (Array.isArray(cartGlobalHoursOfOperation)) return cartGlobalHoursOfOperation;
    return DEFAULT_HOURS;
  })();
  if (!notifications?.length || singleForm?.enabled) return null;
  const handleCallButton = () => {
    trackEvent({
      action: "elementClicked",
      data: {
        elementType: "BUTTON",
        location: "notifications banner",
        position: "header",
        text: "call button " + callInNumber
      }
    });
  };
  return <Fragment>
      <GlobalNotificationStyle />
      {notifications.map((notification, index) => {
      const Icon = iconMap[notification.type] || null;
      return <NotificationsStyled key={index} type={notification.type}>
            {Icon && <div className="notification__status-icon">
                <Icon />
              </div>}
            <p className="notification__message" data-testid="notification__message">
              {React.Children.map(notification.message.split(/(##phoneNumber##|\*tooltip\*)/gim), (message, idx) => {
            if (message.includes("phoneNumber")) {
              return <a key={idx} href={`tel:${callInNumber}`} onClick={handleCallButton}>
                      {callInNumber}
                    </a>;
            } else if (message.includes("tooltip")) {
              return <Tooltip key={idx} className="tooltip" position="top" theme="light" html={<div className="tooltip-info">
                          <strong>Hours of Operation</strong>
                          <ul>
                            {hoursOfOperation.map((hours, key) => <li key={key} {...setHtml(hours)} />)}
                          </ul>
                        </div>}>
                      <InfoCircle />
                    </Tooltip>;
            } else {
              return <span key={idx} {...setHtml(message)} />;
            }
          })}
            </p>
          </NotificationsStyled>;
    })}
    </Fragment>;
};
Notifications.displayName = "Notifications";
export default Notifications;